export default __webpack_public_path__ + "b7775fc7519b1af3474e0c3b971eac05.png";